import { useContext } from 'react';
import { Route } from 'react-router-dom';
import { Context } from '../contexts/AuthContext';
import history from '../routes/history';

export function CustomRoute({ component: Component, isPrivate, ...rest }) {
  const { authenticated, loading } = useContext(Context);

  if (loading) {
    return <h1>Carregando...</h1>;
  }
  if (!authenticated && isPrivate) {
    history.push('/login');
    history.go();
  }

  return (
    <Route {...rest} render={({ location }) => <Component {...location} />} />
  );
}
